import App from './App.vue';
import { user } from '@/beforeGuard/defaultRules';

export default {
  path: '/CDS_VF_Attachment',
  name: 'CDS_VF_Attachment',
  component: App,
  meta: {
    pageProperty: {
      title: '添付ファイル',
      controller: 'CDS_CTR_Attachment',
    },
    guardRules: [user],
  },
};
